import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-users" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel-hdr mt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nuevo", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "fw-300" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-collapse",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Collapse"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-fullscreen",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Fullscreen"
  })
], -1)
const _hoisted_14 = { class: "panel-container" }
const _hoisted_15 = { class: "panel-content" }
const _hoisted_16 = { class: "row mb-1" }
const _hoisted_17 = { class: "col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "fecha_compra"
}, "Fecha", -1)
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = ["onKeyup"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" }, null, -1)
const _hoisted_23 = { class: "col-xl-12" }
const _hoisted_24 = {
  id: "panel-listado",
  class: "panel"
}
const _hoisted_25 = { class: "panel-hdr mt-2" }
const _hoisted_26 = { class: "fw-300" }
const _hoisted_27 = {
  class: "ml-3 text-danger font-weight-bold font-italic",
  style: {"font-size":"18px"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-collapse",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Collapse"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-fullscreen",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Fullscreen"
  })
], -1)
const _hoisted_29 = { class: "panel-container" }
const _hoisted_30 = { class: "panel-content" }
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = { class: "col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" })
  ])
], -1)
const _hoisted_36 = { class: "text-right" }
const _hoisted_37 = { class: "custom-control custom-checkbox ml-3" }
const _hoisted_38 = ["id", "name", "checked"]
const _hoisted_39 = ["for"]
const _hoisted_40 = { class: "table-responsive" }
const _hoisted_41 = { class: "table table-bordered table-sm mt-2 mb-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"50px"}
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, "Producto"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"150px"}
    }, "Cantidad"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"150px"}
    }, "P/Unitario"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"150px"}
    }, "Importe")
  ])
], -1)
const _hoisted_43 = {
  scope: "row",
  class: "text-right",
  style: {"padding-top":"11px"}
}
const _hoisted_44 = { style: {"padding-top":"12px"} }
const _hoisted_45 = {
  class: "text-right",
  style: {"padding-top":"11px"}
}
const _hoisted_46 = {
  class: "text-right",
  style: {"padding-top":"11px"}
}
const _hoisted_47 = {
  class: "text-right",
  style: {"padding-top":"11px"}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

import { onMounted, ref, } from 'vue'; 
import { useRouter } from 'vue-router';
import numeral from 'numeral';

import useCompras from '../composables/useCompras';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComprasAdminView',
  setup(__props) {

const router = useRouter();
const {
    obtenerComprasPorFecha,
} = useCompras();

const totalCompras = ref<any>(0);

const hoy = new Date();
const fitroBusqueda = ref<any>({
    textoBuscar: hoy.getFullYear().toString()
        + '-' + ((hoy.getMonth() + 1) < 10 ? '0' + (hoy.getMonth() + 1).toString() : (hoy.getMonth() + 1).toString())
        + '-' + (hoy.getDate() < 10 ? '0' + hoy.getDate().toString() : hoy.getDate().toString())
});

const headers = [
    { text: 'Sucursal', value: 'nombre_sucursal', sortable: true },
    { text: 'Proveedor', value: 'nombre_proveedor', sortable: true },
    { text: 'Fecha', value: 'fecha_compra', sortable: true },
    { text: 'Tipo Pago', value: 'nombre_tipo_pago', sortable: true },
    { text: 'Total', value: 'total', sortable: true },
    { text: 'Estado', value: 'estado', sortable: true },
];

let compras: any = [];
const comprasFiltrados = ref<any[]>([]);

const textoFiltro = ref<string>('');

onMounted(async() => {
    await buscarCompras();
});

const buscarCompras = async () => {
    textoFiltro.value = '';
    const resp = await obtenerComprasPorFecha(fitroBusqueda.value.textoBuscar);
    if (resp.ok) {
        compras = resp.data;
        comprasFiltrados.value = JSON.parse(JSON.stringify(compras));

        calcularTotalCompras();
    }
}

const calcularTotalCompras = async() => {
    totalCompras.value = 0;
    comprasFiltrados.value.forEach((compra: any) => {
        totalCompras.value += Number(compra.total);
    });
}

const nuevaCompra = async () => {
    router.push({ name: 'compras-editar' });
}

const filtrarInformacion = async () => {
    comprasFiltrados.value = JSON.parse(JSON.stringify(
        compras.filter(
            (u: any) => u.nombre_sucursal.toLowerCase().includes(textoFiltro.value.toLowerCase())
                || u.nombre_proveedor.toLowerCase().includes(textoFiltro.value.toLowerCase())
                || u.fecha_compra.toLowerCase().includes(textoFiltro.value.toLowerCase())
                || u.nombre_tipo_pago.toLowerCase().includes(textoFiltro.value.toLowerCase())
                || u.total.toLowerCase().includes(textoFiltro.value.toLowerCase())
        )
    ));

    calcularTotalCompras();
}

return (_ctx: any,_cache: any) => {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", { class: "float-left" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mr-2",
                  title: "Nuevo",
                  onClick: nuevaCompra
                }, _hoisted_11)
              ]),
              _createElementVNode("h2", null, [
                _createTextVNode(" Filtro de"),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
                ])
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          id: "fecha_compra",
                          name: "fecha_compra",
                          class: "form-control form-control-sm",
                          placeholder: "Fecha de compra",
                          autocomplete: "off",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fitroBusqueda.value.textoBuscar) = $event)),
                          onKeyup: _withKeys(buscarCompras, ["enter"])
                        }, null, 40, _hoisted_21), [
                          [
                            _vModelText,
                            fitroBusqueda.value.textoBuscar,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", { class: "input-group-append" }, [
                          _createElementVNode("button", {
                            class: "btn btn-primary btn-sm mb-2",
                            id: "btn-buscar-compras",
                            name: "btn-buscar-compras",
                            type: "button",
                            onClick: buscarCompras
                          }, [
                            _hoisted_22,
                            _createTextVNode(" Buscar ")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h2", null, [
                _createTextVNode(" Listado de"),
                _createElementVNode("span", _hoisted_26, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
                ]),
                _createElementVNode("span", _hoisted_27, _toDisplayString(`Total general: Bs. ${ _unref(numeral)(totalCompras.value).format('0,0.00') }.-`), 1)
              ]),
              _hoisted_28
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "texto-buscar",
                          name: "texto-buscar",
                          class: "form-control form-control-sm flex",
                          placeholder: "Buscar",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textoFiltro).value = $event)),
                          onInput: filtrarInformacion
                        }, null, 544), [
                          [_vModelText, textoFiltro.value]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_EasyDataTable, {
                  headers: headers,
                  items: comprasFiltrados.value,
                  "border-cell": "",
                  alternating: "",
                  "buttons-pagination": ""
                }, {
                  "item-total": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(numeral)(item.total).format('0,0.00')), 1)
                  ]),
                  "item-estado": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "custom-control-input",
                        id: 'estado' + item.id_cliente,
                        name: 'estado' + item.id_cliente,
                        checked: item.estado
                      }, null, 8, _hoisted_38),
                      _createElementVNode("label", {
                        class: "custom-control-label",
                        for: 'estado_' + item.id_cliente
                      }, null, 8, _hoisted_39)
                    ])
                  ]),
                  expand: _withCtx((item) => [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("table", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.compras_detalle, (compraDetalleItem, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                              _createElementVNode("th", _hoisted_43, _toDisplayString(i + 1), 1),
                              _createElementVNode("td", _hoisted_44, _toDisplayString(compraDetalleItem.nombre_producto), 1),
                              _createElementVNode("td", _hoisted_45, _toDisplayString(compraDetalleItem.cantidad), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(_unref(numeral)(compraDetalleItem.precio_compra).format('0,0.00')) + ".- ", 1),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(_unref(numeral)(compraDetalleItem.importe).format('0,0.00')) + ".- ", 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["items"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_48
  ], 64))
}
}

})